import { Option } from "./option";
export class Options {
  option: Option[];
}

 
